require('./bootstrap');

window.moment = require('./moment.min');
window.moment.locale($('html').attr('lang'));
const Hammer = require('./jquery.hammer');
const claentim = require('./calentim');

require('easy-autocomplete')

const Swal = require('sweetalert2/dist/sweetalert2.min.js');

const { google, outlook, office365, yahoo, ics } = require("calendar-link");

// check if an element exists in array using a comparer function
// comparer : function(currentElement)
Array.prototype.inArray = function(comparer) {
    for(var i=0; i < this.length; i++) {
        if(comparer(this[i])) return true;
    }
    return false;
};

// adds an element to the array if it does not already exist using a comparer
// function
Array.prototype.pushIfNotExist = function(element, comparer) {
    if (!this.inArray(comparer)) {
        this.push(element);
    }
};

var api = {
    delete_cookie: function (name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    setCookie: function(cname, cvalue, hours) {
        var d = new Date();
        d.setTime(d.getTime() + (hours*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    inArray : function(element, array){
        array.pushIfNotExist(element, function(e) {
            return e.name === element.name && e.text === element.text;
        });
    },
    showMessage : function(texts, callback){
        var config = {
            title: texts.title,
            icon: texts.type,
            onfirmButtonColor: '#D88B6C',
            confirmButtonText: translations.ok
        };

        if(texts.ok_btn !== undefined && texts.ok_btn.length)
        {
            config.confirmButtonText = texts.ok_btn;
        }

        if(texts.cancel_btn !== undefined && texts.cancel_btn.length)
        {
            config.cancelButtonColor = '#D88B6C';
            config.showCancelButton = true;
            config.cancelButtonText = texts.cancel_btn;
        }

        Swal.fire(config).then((result) => {
            if (result.isConfirmed) {
                if(callback.length)
                {
                    callback();
                }
            }
        });
    }
}

function validateEmail(email) {
    email = trim(email);
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validatePhone(p)
{
    var phoneRe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    var digits = p.replace(/\D/g, "");
    return (digits.match(phoneRe) !== null);
}

function validate(form, fields)
{
    var status = true;
    fields = fields === '' ? jQuery('input.required,checkbox.required,textarea.required,select.required', form) : fields;
    jQuery('input,checkbox,textarea,select,.ck-editor', form).removeClass('error');

    fields.each(function(index){
        var field = jQuery(this);
        var type = field.attr('type');
        var value = field.val();
        var name= field.attr("name");
        if(value == -1 || value == 0 || value.length == 0)
        {
            status = false;
            if(type == 'radio' || type == 'checkbox')
            {
                field.parents('label').addClass('error');
            }
            else
            {
                if(this.localName == 'textarea' && field.hasClass('editor'))
                {
                    $('.ck-editor').addClass('error');
                }
                field.addClass('error');
            }

        }
        if(name == "email")field.val(trim(value));

        if((name == "email") && !validateEmail(value))
        {
            status = false;
            field.addClass('error');
        }
        if(name == "phone" && (!validatePhone(value) || value.length < 6))
        {
            status = false;
            field.addClass('error');
        }
    });
    return status;
}

var editors = [];
var show_trans_error = true;
function updateSourceElements() {
    editors.forEach(function(editor) {
        editor.updateSourceElement();
    });
}

$(document).ready(function(){

    $('.js-cookie-consent').on('click',function(){
        var timestamp = $(this).attr('data-time');
        api.setCookie('cookies_consent',timestamp, 8760);
        $('#cookie-law-info-bar').fadeOut();
    })

    if($('#delete_event_modal').length)
    {
        $('#delete_event_modal').modal('show');
    }

    $(document).on('click','.terms-toggle',function(e){
       $('#terms').prop('checked',($(this).attr('data-value') == '1' ? true : false));
    });

    $('input[name^="image_"]').on('change', function(event) {
        var file = event.target.files[0];
        var maxSize = 1 * 1024 * 1024 * 5; // 10 MB

        if (file.size > maxSize) {
            $(this).val('');
            api.showMessage({'title':translations.file_too_big,'type': 'error'});
        }

        var allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];

        var extension = file.name.split('.').pop().toLowerCase();

        if (allowedExtensions.indexOf(extension) === -1) {
            $(this).val('');
            api.showMessage({'title':translations.invalid_file_type,'type': 'error'});
            return;
        }
    });

   $(document).on('click','.js-add-to-fav',function (e){
       e.preventDefault();
        var id = $(this).data('id');
        var token = $('meta[name="csrf-token"]').attr('content');
        var $this = $(this);
       $.ajax({
           type: 'POST',
           url: '/api/add_to_favorites',
           dataType: 'json',
           data: {
               'id' : id,
               '_token' : token
           },
           success:function(response) {
               if(response.loggedin)
               {
                   if(response.status)
                   {
                       $this.addClass('active');
                   }
                   else{
                       $this.removeClass('active');
                   }

                   Swal.fire({
                       position: 'top-end',
                       icon: 'success',
                       title: (response.status ? translations.added_to_favorites : translations.removed_from_favorites),
                       showConfirmButton: false,
                       backdrop:false,
                       padding: '0.75rem',
                       timer: 1500
                   });
               }
               else{
                   Swal.fire({
                       title: translations.login_modal_title,
                       icon: 'warning',
                       showCancelButton: true,
                       confirmButtonColor: '#D88B6C',
                       cancelButtonColor: '#616161',
                       cancelButtonText: translations.cancel_btn,
                       confirmButtonText: translations.login_btn
                   }).then((result) => {
                       if (result.isConfirmed) {
                           location='/login';
                       }
                   })
               }
           }
       });
   });
   $(document).on('click','.print-event',function (e) {
        e.preventDefault();

        var w = window.open();
        w.document.write($('.event-page').html());
        w.print();
        w.close();
    });

    let editor;

    function save_event_date(el)
    {
        var status = true;
        var parent = el.parents('fieldset');
        var next = el;

        if(el.attr('data-step') == 1)
        {
            var fields = $('input.required,select.required,textarea.required', parent);

            if(!validate(parent, fields))
            {
                api.showMessage({
                    title: translations.check_required_fields,
                    type: 'warning',
                },'');

                return false;
            }
        }

        if(el.attr('data-step') == 2)
        {
            updateSourceElements();

            var fields = $('input.required,select.required,textarea.required', parent);

            if(!validate(parent, fields))
            {
                api.showMessage({
                    title: translations.check_required_fields,
                    type: 'warning',
                },'');

                return false;
            }

            if(show_trans_error)
            {
                var trans = [];
                $('.name-translation').each(function()
                {
                    if($(this).val().length)
                    {
                        trans.push($(this).attr('data-lang'));
                    }
                });
                if(trans.length == 1)
                {
                    var config = {
                        title: translations.add_more_translations,
                        icon: 'info',
                        onfirmButtonColor: '#D88B6C',
                        confirmButtonText: translations.add_translations,
                        cancelButtonColor : '#D88B6C',
                        showCancelButton : true,
                        cancelButtonText : translations.dont_add_translations,
                    };

                    Swal.fire(config).then((result) => {
                        show_trans_error = false;
                        if (result.isConfirmed) {
                            $('a[href="#content-en"]').click();
                            $('input[name="lt"]').focus();
                        }
                        else
                        {
                            $('.next.action-button[data-step="2"]').click();
                        }
                    });

                    return false;
                }
            }
        }

        if(el.attr('data-step') == 3)
        {
            if($('img',parent).length == 0)
            {
                api.showMessage({
                    title: translations.select_event_image,
                    type: 'warning',
                },'');

                return false;
            }
        }
        if(el.attr('data-step') == 4)
        {
            if($('input[name="phone"]', parent).val().length)
            {
                if(!validate(parent, $('input[name="phone"]', parent)))
                {
                    api.showMessage({
                        title: translations.invalid_phone_format,
                        type: 'warning',
                    },'');

                    return false;
                }
            }

            if($('input[name="free"]:checked', parent).val() == 0)
            {
                if(!$('input[name="price_unknown"]', parent).is(':checked'))
                {
                    if(!validate(parent, $('input[name="price_from"]', parent)))
                    {
                        api.showMessage({
                            title: translations.invalid_or_empty_price,
                            type: 'warning',
                        },'');

                        return false;
                    }
                }
            }
        }

        if(el.attr('data-step') == 5)
        {
            var places_count = $('.event-place-date').length;

            if(!$('input[name="place_id"]').val().length && places_count == 0)
            {
                if(!validate(parent, $('.js-place-and-date-data', parent)))
                {
                    api.showMessage({
                        title: translations.select_or_fill_place_information,
                        type: 'warning',
                    },'');

                    return false;
                }
                if($('img',parent).length == 0)
                {
                    api.showMessage({
                        title: translations.select_place_image,
                        type: 'warning',
                    },'');

                    return false;
                }
            }

            if($('input[name="place_name"]').val().length && !$('input[name="place_id"]').val().length)
            {
                if(!validate(parent, $('.js-place-and-date-data', parent)))
                {
                    api.showMessage({
                        title: translations.select_or_fill_place_information,
                        type: 'warning',
                    },'');

                    return false;
                }
                if($('img',parent).length == 0)
                {
                    api.showMessage({
                        title: translations.select_place_image,
                        type: 'warning',
                    },'');

                    return false;
                }
            }

            if(!$('input[name="terms"]').is(':checked'))
            {
                $('#terms_and_conditions').modal('show');
                return false;
            }
        }

        var fields = $('input,textarea,select',parent);
        fields.push($('input[name="_token"]').first()[0]);

        var data = fields.serialize();

        $.ajax({
            type: 'POST',
            url: '/api/presave_add_event_info',
            dataType: 'json',
            data: data,
            success:function(response) {
                if(next.attr('data-step') == '5')
                {
                    $.ajax({
                        type: 'POST',
                        url: '/api/presave_add_event_info',
                        dataType: 'json',
                        data: data,
                        success:function(response) {
                            if(next.attr('data-step') == '5')
                            {
                                var form = next.parents('form')

                                form.submit();
                            }
                        }
                    });
                }
            }
        });
        return status;
    }


    var current_fs, next_fs, previous_fs; //fieldsets
    var opacity;

    $(".next").click(function(){

        var valid = save_event_date($(this));

        if($(this).attr('data-step') == '5')
        {
            //final step execute ajax submit in save_event_date after data save
        }
        else if(valid){
            current_fs = $(this).parent();
            next_fs = $(this).parent().next();


            $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

            next_fs.show();

            if($("#progressbar li").eq($("fieldset").index(next_fs)).attr('id') == 'event_type')
            {
                $('.add-event-title, .add-event-subtitle').removeClass('d-none');
            }
            else{
                $('.add-event-title, .add-event-subtitle').addClass('d-none');
            }

            current_fs.animate({opacity: 0}, {
                step: function(now) {
                    opacity = 1 - now;
                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    next_fs.css({'opacity': opacity});
                },
                duration: 600
            });

            $("html, body").animate({ scrollTop: 0 }, "fast");
        }

    });

    $(".previous").click(function(){

        current_fs = $(this).parent();
        previous_fs = $(this).parent().prev();

        $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
        previous_fs.show();

        if($("#progressbar li").eq($("fieldset").index(next_fs)).attr('id') == 'event_type')
        {
            $('.add-event-title, .add-event-subtitle').removeClass('d-none');
        }
        else{
            $('.add-event-title, .add-event-subtitle').addClass('d-none');
        }

        current_fs.animate({opacity: 0}, {
            step: function(now) {
                opacity = 1 - now;

                current_fs.css({
                    'display': 'none',
                    'position': 'relative'
                });
                previous_fs.css({'opacity': opacity});
            },
            duration: 600
        });

        $("html, body").animate({ scrollTop: 0 }, "fast");
    });

    $('.radio-group .radio').click(function(){
        $(this).parent().find('.radio').removeClass('selected');
        $(this).addClass('selected');
    });

    $(".submit").click(function(){
        return false;
    });

    $(document).on('click','.add_to_callendar',function(e){
        e.preventDefault();
        var event = $.parseJSON($(this).attr('event'));

        if($(this).attr('data-type') == 'google')
        {
            window.open(google(event));
        }
        if($(this).attr('data-type') == 'outlook')
        {
            window.open(outlook(event));
        }
        if($(this).attr('data-type') == 'office365')
        {
            window.open(office365(event));
        }
        if($(this).attr('data-type') == 'yahoo')
        {
            window.open(yahoo(event));
        }
        if($(this).attr('data-type') == 'ics')
        {
            window.open(ics(event));
        }
    })

    $(".js-place-search").easyAutocomplete({
        url: function(phrase) {
            return "/api/places";
        },

        getValue: function(element) {
            return element.name;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
                dataType: "json"
            }
        },

        preparePostData: function(data) {
            data.phrase = $(".js-place-search").val();

            return data;
        },

        list: {
            onClickEvent: function() {
                var item = $(".js-place-search").getSelectedItemData();

                location = item.url;
            }
        },
        requestDelay: 500
    });

    var message = $('.message');
    if(message.length)
    {
        Swal.fire({
            position: 'top-end',
            icon: message.data('type'),
            title: message.data('title'),
            showConfirmButton: false,
            timer: 1500
        })
    }

    $(".js-place-search-2").easyAutocomplete({
        url: function(phrase) {
            return "/api/places";
        },

        getValue: function(element) {
            return element.name;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
                dataType: "json"
            }
        },

        preparePostData: function(data) {
            data.phrase = $(".js-place-search-2").val();

            return data;
        },

        list: {
            onClickEvent: function() {
                var item = $(".js-place-search-2").getSelectedItemData();

                location = item.url;
            }
        },
        requestDelay: 500
    });

    $(".js-event-search").easyAutocomplete({
        url: function(phrase) {
            return "/api/events";
        },

        getValue: function(element) {
            return element.name;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
                dataType: "json"
            }
        },

        preparePostData: function(data) {
            data.phrase = $(".js-event-search").val();

            return data;
        },

        list: {
            onClickEvent: function() {
                var item = $(".js-event-search").getSelectedItemData();

                location = item.url;
            }
        },
        requestDelay: 500
    });

    $(".js-event-search-2").easyAutocomplete({
        url: function(phrase) {
            return "/api/events";
        },

        getValue: function(element) {
            return element.name;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
                dataType: "json"
            }
        },

        preparePostData: function(data) {
            data.phrase = $(".js-event-search-2").val();

            return data;
        },

        list: {
            onClickEvent: function() {
                var item = $(".js-event-search-2").getSelectedItemData();

                location = item.url;
            }
        },
        requestDelay: 500
    });

    if($('body').hasClass('add-event-page'))
    {
        function MinHeightPlugin(editor) {
            this.editor = editor;
        }

        MinHeightPlugin.prototype.init = function() {
            this.editor.ui.view.editable.extendTemplate({
                attributes: {
                    style: {
                        minHeight: '200px'
                    }
                }
            });
        };

        ClassicEditor.builtinPlugins.push(MinHeightPlugin);

        $("textarea").each(function(){
            ClassicEditor.create(this, {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'underline', 'bulletedList', 'numberedList' ],
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
                    ]
                },
                simpleUpload: {
                    uploadUrl: {
                        url: '/public/ckeditor/upload'
                    }
                }
            }).then(newEditor => {
                console.error('success');
                editors.push(newEditor);
            }).catch(err => {
                console.error(err.stack);
            });
        });



        function reset(e) {
            e.val('');
        }

        function ajax_file_upload(file_obj, input) {
            var previewZone = input.parent().parent().find('.preview-zone');

            if(file_obj != undefined) {
                var form_data = new FormData();
                form_data.append('_token', $('input[name="_token"]').val());
                form_data.append('input_name', input.attr('name'));
                for(i=0; i<file_obj.length; i++) {
                    form_data.append('upload[]', file_obj[i]);
                }
                $.ajax({
                    type: 'POST',
                    url: '/public/file/upload',
                    contentType: false,
                    processData: false,
                    data: form_data,
                    success:function(response) {
                        if(response.errors != undefined)
                        {
                            api.showMessage({
                                'type' : 'error',
                                'title' : translations.one_or_more_invalid_images
                            },'');

                            $.each(response.errors, function(index, value){
                                console.log(index)
                                $('.image-item[data-name="'+index+'"]',previewZone).remove();
                            })
                        }
                        $('.dropzone').val('');
                    },
                    error: function (request, status, error) {
                        var response = $.parseJSON(request.responseText);

                        if(response.errors != undefined)
                        {
                            api.showMessage({
                                'type' : 'error',
                                'title' : translations.one_or_more_invalid_images
                            },'');



                            $('.image-item',previewZone).last().remove();
                        }
                    }
                });
            }
        }

        function clear_uploaded_images(input_name)
        {
            $.ajax({
                type: 'POST',
                url: '/public/file/upload',
                dataType: 'json',
                data: {
                    '_token':$('input[name="_token"]').val(),
                    'input_name' : input_name,
                    'clear':1
                },
                success: function(response) {

                }
            });
        }

        var imagesPreview = function(input) {

            if (input.files) {
                var filesAmount = input.files.length;
                var j = 0;
                var maxSize = 1 * 1024 * 1024 * 5;
                var allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
                var validFiles = [];

                for (i = 0; i < filesAmount; i++) {

                    var file = input.files[i];

                    var extension = file.name.split('.').pop().toLowerCase();
                    if (allowedExtensions.indexOf(extension) === -1) {
                        api.showMessage({'title':'['+input.files[j].name+'] - '+translations.invalid_file_type,'type': 'error'});
                        if(j >= 0) j++
                        continue; // Skip this file
                    }

                    if (file.size > maxSize) {
                        api.showMessage({'title':'['+input.files[j].name+'] - '+translations.file_too_big,'type': 'error'});
                        if(j >= 0) j++
                        continue; // Skip this file
                    }

                    validFiles.push(file);

                    var reader = new FileReader();

                    reader.onload = function(e) {

                        var htmlPreview =
                            '<div class="col-12 col-md-4 image-item" data-name="'+input.files[j].name+'"><img style="width:100%;" src="' + e.target.result + '" />' +
                            '<p>'+input.files[j].name+'</p></div>';
                        var wrapperZone = $(input).parent();
                        var previewZone = $(input).parent().parent().find('.preview-zone');
                        var boxZone = $(input).parent().parent().find('.preview-zone').find('.box').find('.box-body');

                        wrapperZone.removeClass('dragover');
                        previewZone.removeClass('d-none');
                        boxZone.append(htmlPreview);
                        if(j >= 0) j++
                    }

                    reader.readAsDataURL(input.files[i]);
                }

                if (validFiles.length > 0) {
                    ajax_file_upload(validFiles, $(input))
                }
            }

        };

        $(".dropzone").change(function() {
            imagesPreview(this);

        });

        $('.dropzone-wrapper').on('dragover', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass('dragover');
        });

        $('.dropzone-wrapper').on('dragleave', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).removeClass('dragover');
        });

        $('.remove-preview').on('click', function() {
            var boxZone = $(this).parents('.preview-zone').find('.box-body');
            var previewZone = $(this).parents('.preview-zone');
            var dropzone = $(this).parents('.form-group').find('.dropzone');
            boxZone.empty();
            previewZone.addClass('d-none');
            reset(dropzone);
            clear_uploaded_images(dropzone.attr('name'));
        });

        $(document).on('click','.js-add-artist',function(e){
           e.preventDefault();
           var name = $('#artist').val();
            $('#artist').removeClass('error');
           if(name.length)
           {
               var html = '<li class="list-group-item d-flex justify-content-between align-items-center"><input type="hidden" name="artist[]" value="'+name+'"/>'+name+'<span class="btn btn-danger float-right js-remove-artist"><i class="icon-remove white"></i></span></li>';
               $('.artists').append(html);
               $('#artist').val('');
           }
           else{
               $('#artist').addClass('error');
               api.showMessage({
                   title : translations.artist_name_field_is_empty,
                   type : 'warning'
               },'')
           }

        });
        $(document).on('click','.js-remove-artist',function(e) {
            e.preventDefault();
            $(this).parent().remove();
        });


        $(document).on('click','.js-add-another-date',function(e) {
            e.preventDefault();

            var valid = true;
            var parent = $(this).parents('fieldset');
            var data = {};
            $('.js-place-and-date-data').each(function(e){
                var val = $(this).val();
                data[$(this).attr('name')] = val;
            });

            var place_id = $('input[name="place_id"]').val();

            if(place_id.length == 0)
            {
                if(!validate(parent, $('.js-place-and-date-data', parent)))
                {
                    api.showMessage({
                        title: translations.select_or_fill_place_information,
                        type: 'warning',
                    },'');

                    return false;
                }
                if($('img',parent).length == 0)
                {
                    api.showMessage({
                        title: translations.select_place_image,
                        type: 'warning',
                    },'');

                    return false;
                }
            }
            else{
                if(!validate(parent, $('input[name="start_date"],input[name="start_time"],input[name="end_date"],input[name="end_time"]', parent)))
                {
                    api.showMessage({
                        title: translations.select_event_date_time,
                        type: 'warning',
                    },'');

                    return false;
                }
                else{
                    if($('input[name="start_date"]').val() == $('input[name="end_date"]').val())
                    {
                        var start_time = $('input[name="start_time"]').val();
                        var end_time = $('input[name="end_time"]').val();

                        var start_time_parts = start_time.split(':');
                        var end_time_parts = end_time.split(':');

                        var start_hour = parseInt(start_time_parts[0]);
                        var end_hour = parseInt(end_time_parts[0]);

                        if(start_time == end_time)
                        {
                            api.showMessage({
                                title: translations.start_and_end_time_can_not_be_the_same,
                                type: 'warning',
                            },'');

                            return false;
                        }

                        if(start_time > end_time)
                        {
                            api.showMessage({
                                title: translations.invalid_start_end_time,
                                type: 'warning',
                            },'');

                            return false;
                        }

                    }
                }
            }

            data['_token'] = $('input[name="_token"]').val();

            if(place_id.length)
            {
                data['place_id'] = place_id;
            }

            data['google_link'] = $('input[name="google_link"]').val();

            $.ajax({
                type: 'POST',
                url: '/api/add_date_place_data',
                dataType: 'json',
                data: data,
                success: function(response) {
                    if(response.status)
                    {
                        $('.js-place-and-date-data').val('');
                        $('input[name="place_id"]').val('');
                        $('.place_address,.place_type,.place-image,.google_link').removeClass('d-none');

                        $('.place-image .image-item').remove();

                        var index = $('.event-place-date').length;

                        index++;

                        var html = '<div class="event-place-date row">'+
                            '<div class="col-12 col-md-3 date-field">'+data.start_date+' '+data.start_time+'</div>'+
                            '<div class="col-12 col-md-8 name-field">'+data.place_name+'</div>'+
                            '<div class="col-12 col-md-1 btn-field"><span class="js-remove-date-place-data" data-index="'+(index-1)+'"><i class="icon-remove"></i></span></div>'+
                            '</div>';

                        $('.event-date-place-list').append(html).removeClass('d-none');
                    }
                    else{

                    }
                }
            });
        });

        $(document).on('click','.js-remove-date-place-data',function(e) {
            e.preventDefault();
            var index = $(this).data('index');
            var $this = $(this);
            $.ajax({
                type: 'GET',
                url: '/api/remove_date_place_data',
                dataType: 'json',
                data: {
                    'index' : index
                },
                success: function (response) {
                    if (response.status) {
                        $this.parents('.event-place-date').remove();

                        if(!$('.event-place-date').length)
                        {
                            $('.event-date-place-list').addClass('d-none');
                        }
                    }
                }
            });
        });
    }

    $(document).on('click','.js-load-more',function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $this.attr('data-url');
        var page = parseInt($this.attr('data-page'));
        var list_item_last = $('.list-item').last();
        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'html',
            data: {
                'page' : page
            },
            success: function (response) {
                if(response.length)
                {
                    $('.list-to-append').append(response);
                    $this.attr('data-page', (page+1));

                    $("html, body").animate({ scrollTop: list_item_last.position().top }, "fast");

                }
                else{
                    $this.hide();
                }

            }
        });
    });

    var locale = $('html').attr('lang');

    $.ajax({
        type: 'GET',
        url: '/api/get_events_ranges',
        dataType: 'json',
        success:function(response) {
            var ranges = [];
            $.each(response,function(index, event){
                ranges.push({
                    "start": moment(event.start,"YYYY-MM-DD"),
                    "end": moment(event.end, "YYYY-MM-DD")
                })
            });

            $(".sticky-calendar").calentim({
                minDate: moment(),
                singleDate: true,
                calendarCount: 1,
                startOnMonday : true,
                showTimePickers : false,
                format: "YYYY-MM-DD",
                showFooter : false,
                showHeader: false,
                enableKeyboard: false,
                autoCloseOnSelect: true,
                custom_footer: true,
                target: $(".main-calendar"),
                showOn:"left",
                locale: locale,
                cancelLabel: translations.cancel,
                applyLabel : translations.apply,
                autoAlign:true,
                hasEventsRanges: ranges,
                onafterselect: function(calentim, startDate){
                    var day = startDate.format('DD');
                    $(".sticky-calendar span").html(day);

                    var link = $(".sticky-calendar").attr('data-link');

                    location = link.replace("DATE",startDate.format('YYYY-MM-DD'));
                }
            });
        }
    });

    $(document).on('click', '.js-calendar-current-month', function(){
        var link = $(".sticky-calendar").attr('data-link');

        var month = parseInt($(this).attr('data-month'));
        location = link.replace("DATE",$(this).attr('data-year')+'-'+(month<10?'0':'')+month);
    });


    $(".datepicker").calentim({
        minDate: moment(),
        singleDate: true,
        calendarCount: 2,
        startOnMonday : true,
        showTimePickers : false,
        format: "YYYY-MM-DD",
        showFooter : false,
        showHeader: false,
        locale: locale,
        cancelLabel: translations.cancel,
        applyLabel : translations.apply,
        enableKeyboard: false,
        autoCloseOnSelect: true,
        onafterselect: function(calentim, startDate){
            if(calentim.$elem.attr('name') == 'start_date')
            {
                var end_date_calentim = $("input[name='end_date']").data("calentim");
                end_date_calentim.setStart(startDate);
                end_date_calentim.updateInput();
            }
        }
    });
    $(".timepicker").calentim({
        singleDate: true,
        calendarCount: 2,
        showCalendars : false,
        format: "HH:mm",
        hourFormat: 24,
        showHeader: false,
        locale: locale,
        cancelLabel: translations.cancel,
        applyLabel : translations.apply,
        enableKeyboard: false,
        showButtons: true,
        minuteSteps: 5,
        oninit: function(calentim){
            var start_time = moment();
            start_time.set({hour:18,minute:0,second:0,milisecond:0});

            if(calentim.$elem.attr('name') == 'end_time')
            {
                start_time.set({hour:19,minute:0,second:0,milisecond:0});
            }
            calentim.setStart(start_time);
        },
        onafterselect: function(calentim, startDate){
            if(calentim.$elem.attr('name') == 'start_time')
            {
                var end_date_calentim = $("input[name='end_time']").data("calentim");
                end_date_calentim.setStart(startDate.add(1, 'hours'));
                end_date_calentim.updateInput();
            }
        }
    });



    $(".place_autocomplete").easyAutocomplete({
        url: function(phrase) {
            return "/api/places";
        },

        getValue: function(element) {
            return element.name;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
                dataType: "json"
            }
        },

        preparePostData: function(data) {
            data.phrase = $(".place_autocomplete").val();

            return data;
        },

        list: {
            onClickEvent: function() {
                $(".place_id").val($(".place_autocomplete").getSelectedItemData().id);
                $('.place_address,.place_type,.place-image,.google_link').addClass('d-none');
                $('.place_address,.place_type,.google_link').val('');
            },
            onHideListEvent : function(){
                var value = $('.place_autocomplete').val();
                console.log(value);
                if(value.length == 0)
                {
                    $('.place_address,.place_type,.place-image,.google_link').removeClass('d-none');
                    $(".place_id").val('');
                }
            }
        },
        requestDelay: 150
    });

    $(document).on('keypress','input[name="phone"]',function(e){
        return /^[0-9 +-]*$/i.test(e.key);
    })

    $(document).on('change','input[name="free"]',function(e){
       if($(this).val() == 0)
       {
           $('.price-data').removeClass('d-none');
       }
       else{
           $('.price-data').addClass('d-none');
       }
    });

    $(document).on('click','.js-place-type-option',function(e){
        $('select[name="place_type"]').val($(this).data('id'));
        $(this).parents('.modal').modal('hide');
    });

    $(document).on('click','.js-category-option',function(e){

        $(this).toggleClass('active');

        var selectedIds = [];
        var selectedNames = [];

        $('.js-category-option.active').each(function() {
            var id = $(this).data('id');
            selectedIds.push(id);

            var name = $(this).data('name');
            selectedNames.push(name);
        });

        var idsString = selectedIds.join(',');
        var namesString = selectedNames.join(', ');

        $('input[name="categories"]').val(namesString);
        $('input[name="category_id"]').val(idsString);
    });

    $(document).on('click','.js-place-option',function(e){
        $('input[name="place_id"]').val($(this).data('id'));
        $('input[name="place_name"]').val($(this).data('name'));
        $('.place_address,.place_type,.place-image,.google_link').addClass('d-none');
        $('.place_address,.place_type').val('');
        $(this).parents('.modal').modal('hide');
    });

    $(document).on('click','.js-confirm-event-delete', function(e) {
        e.preventDefault();
        var $this = $(this);
        Swal.fire({
            title: translations.are_you_sure,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: translations.yes,
            denyButtonText: translations.no,
        }).then((result) => {
            if (result.isConfirmed) {
                location = $this.attr('href');
            } else if (result.isDenied) {

            }
        })
    });
});


